import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NvDropdownModule } from 'Src/nvps-libraries/design/nv-dropdown/nv-dropdown.module';
import { BaseModalModule } from '../../base-modal.module';
import { FinalDecisionMilestoneModalComponent } from './final-decision-milestone-modal.component';

@NgModule({
  declarations: [FinalDecisionMilestoneModalComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule, BaseModalModule, NvDropdownModule],
  exports: [FinalDecisionMilestoneModalComponent],
  entryComponents: [FinalDecisionMilestoneModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FinalDecisionMilestoneModalModule {}
